import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { GiChickenOven } from "react-icons/gi";
// import { useNavigate } from "react-router-dom";
import thankyouImg from "../../assets/img/thankyou.png";
import PostApiCall from "../../helper/PostAPI";
import "./PaymentSuccess.css";
function PaymentSuccess() {
  // const navigate = useNavigate();
  const [orderType, setOrderType] = useState("");
  const [totalOrderValue, setTotalOrderValue] = useState(0);
  useEffect(() => {
    if (JSON.parse(localStorage.getItem("OrderData"))) {
      PostApiCall.postRequest(
        {
          orderid: JSON.parse(localStorage.getItem("OrderData"))?.order_id,
        },
        "getOrderDetails",
      ).then((results) =>
        results.json().then((obj) => {
          if (results.status === 200 || results.status === 201) {
            setOrderType(obj.data[0].fld_order_type);
            CustomerOrderMailer(obj.data);
            setTotalOrderValue(
              parseFloat(obj.data[0].fld_total_net_amount).toFixed(2),
            );
            localStorage.removeItem("OrderData");
            PostApiCall.postRequest(
              {
                customerName: obj.data[0].Customer_name,
                orderValue: parseFloat(
                  obj.data[0].fld_total_net_amount,
                ).toFixed(2),
                phoneNumber: "+12063696165",
              },
              "smsSendToAdmin",
            ).then((res) => {
              if (res.status === 200 || res.status === 201) {
                // localStorage.removeItem("OrderData");
              } else {
                //console.log("error")
              }
            });
          }
        }),
      );
    } else {
      // navigate('/order-online');
    }
  }, []);
  const CustomerOrderMailer = (data) => {
    PostApiCall.postRequest(
      {
        ordernumber: data[0]?.fld_order_number,
        customername: data[0]?.Customer_name,
        customeremail: data[0]?.Customer_email,
        totalamount: data[0]?.fld_cart_amount_no_shipping,
        orderData: data,
        deliverycharge: data[0]?.fld_shipping_charge,
        subtotal: data[0]?.fld_cart_amount,
        taxes: data[0]?.fld_total_gst,
        orderdate: data[0]?.fld_order_date,
        TotalDiscount: data[0]?.fld_total_discount,
        tip: data[0]?.fld_tip,
        orderType: data[0]?.fld_order_type,
      },
      "CustomerOrderMailer",
    ).then((result) =>
      result?.json().then((obj3) => {
        if (result.status == 200 || result.status == 201) {
          // navigate('/payment-successful');
        } else {
          // Notiflix.Notify.Failure("Oops!", "Something went wrong");
        }
      }),
    );
  };
  return (
    <div>
      <Helmet>
        <script>
          {`
            gtag('event', 'conversion', {
                'send_to': 'AW-870655978/6qTVCNGCzL4aEOrPlJ8D',
                'value': ${totalOrderValue},
                'currency': 'USD',
                'transaction_id': ''
            });
          `}
        </script>
      </Helmet>
      <div className="container-fluid payment-succes-main">
        <div className="row mb-4 align-items-center justify-content-center">
          <div className="col-md-10 text-center payment-succes-box py-4">
            <div className="w-100 text-center">
              <img
                src={thankyouImg}
                className="img-fluid payment-succes-icons"
                alt="image"
                loading="lazy"
              />
              <h3 className="fw-normal">Order Confirmed!</h3>
            </div>
            <p>
              Your payment was successful, and your order is being processed.
              We're cooking up your delicious meal right now!
              <GiChickenOven className="mx-2" />{" "}
            </p>
            <p>
              We'll notify you as soon as your order is
              {orderType == "TakeAway" ? "ready." : "on its way.}"}
            </p>
            <p>
              {" "}
              Thank you for choosing <b>Masala of India Cuisine</b>
            </p>
            <div className="text-center w-100 mt-3">
              <button
                className="btn btn-danger btn-md"
                onClick={() => {
                  window.location.href = "/order-online";
                }}>
                Continue Ordering
              </button>
            </div>
            {/* <section className="px-3">
                            {
                                orderType ==
                                    "Take Away" ?
                                    <div>
                                        <p className="payment-success-title">Thank you for ordering</p>
                                        <p className="payment-success-title">Your food will be ready in about 20-25 minutes</p>
                                    </div>
                                    :
                                    orderType ==
                                        "Delivery" ?
                                        <div>
                                            <p className="payment-success-title">Thank you for ordering with us.</p>

                                        </div>
                                        : ""
                            }

                        </section> */}
          </div>
        </div>
      </div>
    </div>
  );
}
export default PaymentSuccess;
